import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=0a6c29e0&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=js&"
export * from "./TableHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=0a6c29e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c29e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6c29e0')) {
      api.createRecord('0a6c29e0', component.options)
    } else {
      api.reload('0a6c29e0', component.options)
    }
    module.hot.accept("./TableHeader.vue?vue&type=template&id=0a6c29e0&scoped=true&", function () {
      api.rerender('0a6c29e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/components/history-table/TableHeader.vue"
export default component.exports